import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getUserFollowMoveTo = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    return user && user.meta && user.meta.isFollowMoveTo;
};
